import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import openSansItalic from "../PDFFonts/OpenSans-Italic.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src:
        "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: openSansItalic,
      fontStyle: "italic",
    },
    {
      src:
        "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-300.ttf",
      fontWeight: "light",
    },

    {
      src:
        "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf", // Bold font
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  GrienvantSecondFooter: {
    textDecoration: "underline",
  },
  container: {
    flexDirection: "row", // Align children horizontally
  },
  mB1: {
    marginBottom: 10,
  },
  boldText: {
    fontFamily: "Open Sans",

    fontWeight: "bold",
  },
  grievanceHeaderLeft: {
    width: "50%",
  },
  signatureRight: {
    width: "50%",
    textAlign: "right",
    float: "right",
  },
  w100: {
    width: "100%",
  },
  signature: {
    width: "70%",
    height: "5px",
    marginTop: "35px",

    borderTop: " 1px solid blank",
  },
  signature2: {
    width: "70%",

    border: " 1px solid blank",
  },
  dBlock: {
    display: "block",
  },

  textItalic: {
    fontStyle: "italic",
  },
  pT4: {
    paddingTop: "34px",
  },
  pT3: {
    paddingTop: "21px",
  },
  pT2: {
    paddingTop: "13px",
  },
  grievanceHeaderRight: {
    width: "50%",

    textAlign: "right",
  },
  paddingTopRight15: {
    paddingRight: 15,
    paddingTop: 15,
  },
  paddingTop15: {
    paddingTop: 15,
  },
  headerImageView: {
    marginLeft: 170,
    marginTop: 20,
  },
  GrienvantFooter: {
    marginTop: 30,
  },
  image: {
    width: 80,
    height: 80,
  },
  floatLeft: {
    float: "left",
  },
  ml30: {
    marginLeft: "30%",
  },
  floatRight: {
    display: "block" /* or inline-block */,
    float: "right",
  },
  textRight: {
    textAlign: "right",
  },
  textLeft: {
    textAlign: "left",
  },
  sec: {
    //marginTop: 80
  },
  Dear: {
    marginTop: 30,
    marginBottom: 30,
  },
  afterSalution: {
    marginTop: 10,
  },
  afterDateText: {
    marginTop: 30,
  },
  dateText: {
    marginTop: 50,
  },
  logoImage: {
    width: 80,
    height: 80,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    fontFamily: "Open Sans",
    fontSize: 12,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: "left",
    marginTop: 20,
    fontFamily: "Oswald",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: "Oswald",
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },

  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
});

export function PdfDocument(props) {
  let Address = props.data && props.data.facilityAddressObj;
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.container}>
          <View
            style={{ ...styles.grievanceHeaderLeft, ...styles.paddingTop15 }}
          >
            <Text>NATCA/{props.data.facilityCode}</Text>
            {Address && (
              <>
                <Text> {Address.address1}</Text>

                {Address.address2 ? <Text> {Address.address2}</Text> : <></>}

                {Address.address3 ? <Text> {Address.address3}</Text> : <></>}

                <Text>
                  {Address.city +
                    (Address.state ? ", " + Address.state : "") +
                    (Address.zipcode ? " " + Address.zipcode : "")}
                </Text>
                <Text>United States</Text>
                <Text style={styles.pT3}>
                  {" "}
                  NATCA Grievance Number: {props.data.grievanceNumber}
                </Text>
              </>
            )}
          </View>
          <View style={styles.grievanceHeaderRight}>
            <Image
              style={{ ...styles.image, ...styles.headerImageView }}
              src="https://upload.wikimedia.org/wikipedia/en/6/67/NATCA_logo.png"
            />
          </View>
        </View>

        <View style={{ ...styles.container, ...styles.pT4 }}>
          <Text style={styles.boldText}>
            Date {props.data.filedStep} Grievance filed:{" "}
          </Text>
          <Text>{props.data.dateFiled}</Text>
        </View>
        <Text style={styles.pT2}>Federal Aviation Administration</Text>
        <Text>{props.data.recipientName}</Text>

        {Address && (
          <>
            <Text style={styles.pT2}> {Address.address1}</Text>

            {Address.address2 ? <Text> {Address.address2}</Text> : <></>}

            {Address.address3 ? <Text> {Address.address3}</Text> : <></>}

            <Text>
              {Address.city +
                (Address.state ? ", " + Address.state : "") +
                (Address.zipcode ? " " + Address.zipcode : "")}
            </Text>
            <Text>United States</Text>
          </>
        )}

        <View style={{ ...styles.container, ...styles.pT2 }}>
          <Text>FAA Grievance Number: </Text>
          <Text>________________</Text>
        </View>

        <View style={{ ...styles.container, ...styles.pT2 }}>
          <Text>Re: Grievance regarding </Text>
          <Text>{props.data.grievanceSubject}</Text>
        </View>

        <Text style={styles.pT2}>{props.data.recipientName},</Text>

        <View style={styles.pT2}>
          <Text>
            This grievance is filed pursuant to Article 9 of the 2016 Collective
            Bargaining Agreement and 5 USC 7103 (a) (9). The Agency's actions
            constitute a violation of the 2016 Agreement, 5 U.S.C. Chapter 71
            and all applicable laws, rules, regulations, and past practice.
          </Text>
        </View>
        <View style={{ ...styles.container, ...styles.pT2 }}>
          <Text style={styles.boldText}>Name of Grievant: </Text>
          <Text>{props.data.isUnion ? "NATCA" : props.data.grievantName}</Text>
        </View>
        <View style={{ ...styles.container }}>
          <Text style={styles.boldText}>Name of Union Representative: </Text>
          <Text>{props.data.representativeName}</Text>
        </View>
        <View style={{ ...styles.container }}>
          <Text style={styles.boldText}>Request Oral Presentation: </Text>
          <Text>{props.data.isMeetingRequested}</Text>
        </View>
        <View style={styles.container}>
          <Text style={styles.boldText}>Date of Violation: </Text>
          <Text>{props.data.voilationDate}</Text>
        </View>

        <View style={{ ...styles.pT2 }}>
          <Text style={{ ...styles.boldText, ...styles.GrienvantSecondFooter }}>
            Nature of the Grievance:
          </Text>
          <Text>{props.data.statementOfFact}</Text>
        </View>

        <View style={{ ...styles.pT2 }}>
          <Text style={{ ...styles.boldText, ...styles.GrienvantSecondFooter }}>
            Remedy Sought:
          </Text>
          <Text>{props.data.remedySought}</Text>
        </View>

        <View style={{ ...styles.container, ...styles.pT2 }}>
          {props.data.representativeName && (
            <View style={styles.grievanceHeaderLeft}>
              <Text style={styles.signature}></Text>
              <Text style={{ ...styles.w100, ...styles.textItalic }}>
                {props.data.representativeName}
              </Text>
            </View>
          )}
          {props.data.recipientName && (
            <View style={styles.signatureRight}>
              <View style={{ ...styles.w100 }}>
                <Text style={{ ...styles.signature, ...styles.ml30 }}></Text>
              </View>
              <Text
                style={{
                  ...styles.w100,
                  ...styles.textLeft,
                  ...styles.textItalic,
                  ...styles.ml30,
                }}
              >
                {props.data.recipientName}
              </Text>
            </View>
          )}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
}
